import { HttpClient } from '@shared/adapters/HttpClient';

export interface CreateManualShopRequest {
  name: string;
  connect_data?: {
    api_key?: string;
    store_url?: string;
  };
}

export interface CreateManualShopResponse {
  success: boolean;
  message: string;
  data?: any;
}

export class ManualShopApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * 🎯 Crear una tienda manual
   * @param shopData - Datos de la tienda a crear
   * @returns Promise con la respuesta de la API
   */
  async createManualShop(
    shopData: CreateManualShopRequest
  ): Promise<CreateManualShopResponse> {
    try {
      const response = await this.httpClient.post<any>('/shops', shopData);

      return {
        success: true,
        message: response.message || 'Tienda manual creada exitosamente',
        data: response,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          'Error al crear la tienda manual',
      };
    }
  }
}
